import p from "./index976.js";
import a from "./index977.js";
import l from "./index978.js";
import s from "./index979.js";
import m from "./index980.js";
function t(o) {
  var e = -1, h = o == null ? 0 : o.length;
  for (this.clear(); ++e < h; ) {
    var r = o[e];
    this.set(r[0], r[1]);
  }
}
t.prototype.clear = p;
t.prototype.delete = a;
t.prototype.get = l;
t.prototype.has = s;
t.prototype.set = m;
export {
  t as default
};
